import React, { useState } from 'react';
import './Dropdown.css';
import '../../Default.css'

type ListProps = {
  children: Array<React.ReactElement>;
};

const Dropdown = ({ children }: ListProps) => {
    const [open, setOpen] = useState(false);
  
    const handleOpen = () => {
      setOpen(!open);
    };
  
    return (
      <div className="dropdown">
        {React.cloneElement(<button className='dropdown-btn'>{children.at(0)}</button>, {
          onClick: handleOpen,
        })}
        {open ? (
          <ul className="dropdown-list">
            {children.map((elem, index) => {
              if (index === 0) return <></>
              else return <li key={index}>
                {React.cloneElement(elem, {
                  onClick: () => {
                    elem.props.onClick();
                    setOpen(false);
                  },
                })}
            </li>
            })}
          </ul>
        ) : null}
      </div>
    );
};

export default Dropdown;